<template>
  <div class="row match-header flex-center-vertical">
    <div
      class="vertical-line"
      :class="`sport-color-${idSport}`"
    />
    <p class="match-display-id text-center flex-noshrink">
      {{ idDisplay }}
    </p>
    <i
      class="match-header-icon n-i"
      :class="`n-i-live-${idSport}`"
    />
    <span class="match-name flex">
      <span class="team flex-center-vertical flex-noshrink">
        <transition name="slide-server">
          <i
            class="server"
            v-if="matchStatus.server === 1"
          />
        </transition>
        <card-red
          :count="matchStatus.redCards[0]"
          v-if="matchStatus.redCards && matchStatus.redCards[0]"
        />
        {{ matchTeams[0].nameShort }}
      </span>
      <span class="team-separator text-center flex-noshrink">
        {{ teamSeparator }}
      </span>
      <span class="team flex-center-vertical flex-noshrink">
        <transition name="slide-server">
          <i
            class="server"
            v-if="matchStatus.server === 2"
          />
        </transition>
        <card-red
          :count="matchStatus.redCards[1]"
          v-if="matchStatus.redCards && matchStatus.redCards[1]"
        />
        {{ matchTeams[1].nameShort }}
      </span>
    </span>
    <span class="filler" />
    <match-results
      :id-match="idMatch"
      :id-sport="idSport"
    />
    <span
      class="period-time font-bold color-important"
      v-if="!isServer">
      {{ periodTime }}
    </span>
  </div>
</template>

<script>
import { server } from '@/services/mixins';
import CardRed from '@/components/common/card-red/CardRed.vue';
import MatchResults from './MatchResults.vue';

export default {
  name: 'MatchHeader',
  mixins: [server],
  components: {
    CardRed,
    MatchResults,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
    idDisplay: {
      required: true,
      type: Number,
    },
    matchStatus: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      teamSeparator: '-',
    };
  },
  computed: {
    matchTeams() {
      return this.$store.getters.getMatchTeams(this.idMatch);
    },
    periodTime() {
      if (this.idSport === 21 && this.matchStatus.overs) {
        return `${this.matchStatus.overs}o`;
      }

      return this.matchStatus.periodTime;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-header {
  color: $color-text-primary;
  border-bottom: 1px solid $color-border;
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }
}

.vertical-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: $match-vertical-line-width;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 1;
}

.match-display-id {
  float: left;
  width: $match-display-id-width;
  height: 100%;
  padding-left: $match-vertical-line-width;
  background-color: $match-id-color-back;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-weight: $font-weight-bold;
  font-size: 0.875rem;
}

.match-header-icon {
  padding-left: 10px;
  font-size: 0.8125rem;
}

.period-time {
  padding: 0 1.041667vw;
  font-size: 0.875rem;
}

.match-name {
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 10px;

  .team {
    position: relative;
    height: calc(5vh - 1px);
    overflow: hidden;
  }

  .team-separator {
    width: $match-team-separator-width;
  }

  .important {
    color: $color-important;
  }
}

.server {
  position: absolute;
  left: 0;
  bottom: 0;
  width: $match-server-width;
  height: $match-server-height;
  border-top-left-radius: $match-server-height;
  border-top-right-radius: $match-server-height;
  background-color: $color-important-special;
}
</style>
